/*       */

import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import LicenseErrorPage from 'app/containers/ErrorPages/LicenseErrorPage';
import License from './License';

class LicenseRoute extends Component {
    static propTypes = {
        userProfile: PropTypes.object,
    };

    render() {
        return (
            <Switch>
                <Route path="/licence-expired" render={props => <LicenseErrorPage {...props} message={this.props.message} />} />
                <Route path="/licence" render={props => <License {...props} isExpired />} />
                <Redirect to="/licence-expired" />
            </Switch>
        );
    }
}

export default connect(state => ({
    userProfile: state.user.profile,
}))(LicenseRoute);
